// Wait for the DOM to be fully loaded
document.addEventListener( 'DOMContentLoaded', function () 
{
    const saveButtons = document.querySelectorAll( '.save_button' );
    const amountSpan = document.querySelector( '.amount' );

    let buttonValue = document.querySelector( '.save_button.active' ).getAttribute( 'data-value' );
    amountSpan.textContent = buttonValue;

    // Add click event listeners to save buttons
    saveButtons.forEach(function ( button ) 
    {
        button.addEventListener( 'click', function () 
        {
            saveButtons.forEach(function ( btn )
            {
                btn.classList.remove( 'active' );
            });

            button.classList.add( 'active' );

            // Update the buttonValue and amountSpan
            buttonValue = button.getAttribute( 'data-value' );
            amountSpan.textContent = buttonValue;
            initializeAmountSpanAnimation( amountSpan );
        });
    });
});

// Function to initialize the animation for the amountSpan
const initializeAmountSpanAnimation = ( amountSpan ) => {
    const pattern = /(\D+)?(\d+)(\D+)?(\d+)?(\D+)?/;
    const animationTime = 700;
    let result = [...pattern.exec(amountSpan.textContent)];
    let fresh = true;
    let ticks;

    result.shift();
    result = result.filter( res => res != null );

    // Clear the content of amountSpan
    while ( amountSpan.firstChild ) 
    {
        amountSpan.removeChild( amountSpan.firstChild );
    }

    for ( let res of result ) 
    {
        if ( isNaN( res ) ) 
        {
            amountSpan.insertAdjacentHTML( 'beforeend', `<span>${res}</span>` );
        } 
        else 
        {
            for ( let i = 0; i < res.length; i++ )  
            {
                amountSpan.insertAdjacentHTML( 'beforeend',
                    `<span data-value="${res[i]}">
                        <span>&ndash;</span>
                        ${Array(parseInt(res[i]) + 1).join(0).split(0).map((x, j) => `
                            <span>${j}</span>
                        `).join('')}
                    </span>`
                );
            }
        }
    }

    ticks = [...amountSpan.querySelectorAll('span[data-value]')];

    // Function to activate the animation when scrolled or touched
    const activateAnimation = () => 
    {
        let top = amountSpan.getBoundingClientRect().top;
        let offset = window.innerHeight * 3 / 4;

        setTimeout(() => 
        {
            fresh = false;
        }, animationTime);

        if ( top < offset )
        {
            setTimeout(() => 
            {
                for ( let tick of ticks ) 
                {
                    let dist = parseInt( tick.getAttribute( 'data-value' ) ) + 1;
                    tick.style.transform = `translateY(-${(dist) * 100}%)`;
                }
            }, fresh ? animationTime : 0 );

            // Remove event listeners once animation is activated
            window.removeEventListener( 'scroll', activateAnimation );
            window.removeEventListener( 'touchstart', activateAnimation );
        }
    };

    // Add event listeners for activating the animation
    window.addEventListener( 'touchstart', activateAnimation );
    window.addEventListener( 'scroll', activateAnimation );
    activateAnimation();
};

// Call the initializeAmountSpanAnimation function with the amountSpan
document.addEventListener('DOMContentLoaded', function () 
{
    const amountSpan = document.querySelector( '.amount' );
    initializeAmountSpanAnimation( amountSpan );
});
